var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticStyle:{"background":"#f2f2f2"}},[_c('common-head',{attrs:{"active":"1","state":"1"}}),_c('div',{staticClass:"pro"},[_c('div',{staticClass:"pro-content",domProps:{"innerHTML":_vm._s(_vm.info.product_content)}})]),_c('common-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }